import { render, staticRenderFns } from "./TutoList.vue?vue&type=template&id=21c4c952&scoped=true&"
import script from "./TutoList.vue?vue&type=script&lang=js&"
export * from "./TutoList.vue?vue&type=script&lang=js&"
import style0 from "./TutoList.vue?vue&type=style&index=0&id=21c4c952&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c4c952",
  null
  
)

component.options.__file = "TutoList.vue"
export default component.exports